import type {
  Meter,
  Settings,
  Zone,
} from "@/lib/tool-kit/games-organizers/noise-meter";

export const ZONE_FILL: Record<Zone, string> = {
  quiet: "bg-emerald-500",
  talk: "bg-amber-500",
  loud: "bg-red-500",
};

/** The big horizontal bar: three zones behind, the level in front, a peak marker on top. */
export default function NoiseBar({
  meter,
  settings,
  label,
  valueText,
}: {
  meter: Meter;
  settings: Settings;
  label: string;
  valueText: string;
}) {
  return (
    <>
      <meter
        aria-label={label}
        aria-valuetext={valueText}
        className="sr-only"
        max={100}
        min={0}
        value={Math.round(meter.level)}
      >
        {valueText}
      </meter>
      <div
        aria-hidden="true"
        className="relative h-14 overflow-hidden rounded-lg border border-border bg-muted sm:h-20"
      >
        <div
          aria-hidden="true"
          className="absolute inset-y-0 left-0 bg-emerald-500/15"
          style={{ width: `${settings.quietBelow}%` }}
        />
        <div
          aria-hidden="true"
          className="absolute inset-y-0 bg-amber-500/15"
          style={{
            left: `${settings.quietBelow}%`,
            width: `${settings.loudAbove - settings.quietBelow}%`,
          }}
        />
        <div
          aria-hidden="true"
          className="absolute inset-y-0 right-0 bg-red-500/15"
          style={{ width: `${100 - settings.loudAbove}%` }}
        />
        <div
          aria-hidden="true"
          className={`absolute inset-y-2 left-0 rounded-r-md sm:inset-y-3 ${ZONE_FILL[meter.zone]}`}
          style={{ width: `${meter.level.toFixed(1)}%` }}
        />
        <div
          aria-hidden="true"
          className="absolute inset-y-0 w-1 bg-foreground"
          style={{ left: `${Math.min(99, meter.peak).toFixed(1)}%` }}
        />
      </div>
    </>
  );
}
